import Vue from 'vue';
import { HttpPlugin } from '@baseball-systems/http';
import { ResponsivePlugin } from '@baseball-systems/responsive';

const PlayerOverviewSection = () => import('./playerOverview/PlayerOverviewSection.vue');
const BatMetricTableSection = () => import('./batMetricsTable/TableSection.vue');
const IFOFDefPerformanceTable = () => import('./defenseGrids/IFOFDefensePerformance.vue');
const CatcherProcessTable = () => import('./defenseGrids/CatcherProcess.vue');
const CatcherDefPerformanceTable = () => import('./defenseGrids/CatcherDefensePerformance.vue');
const IFOpinion = () => import('./defenseGrids/IFOpinion.vue');
const OFOpinion = () => import('./defenseGrids/OFOpinion.vue');
const DefenseGrid = () => import('./defenseGrids/DefenseGrid.vue');

const InjuryForecast = () => import('./injuryForecast/InjuryForecast.vue');
const AmateurMedical = () => import('./amateurMedical/AmateurMedical.vue');

const FxSwingGrades = () => import('dv/pdev/lib/Vue/hitter_assessments/FxSwingGrades/FxSwingGrades.vue');

const PlayerJournalEntryModalContent = () => import('./playerJournalEntries/PlayerJournalEntryModalContent.vue');

import { addToQuickNav } from './defenseGrids/helpers';
import tracing from 'library/helpers/tracing';
import {
  CATCHER_PROCESS_TABLE_ID,
  CATCHER_PROCESS_TABLE_NAME,
  CATCHER_TABLE_ID,
  CATCHER_TABLE_NAME,
  DEFENSE_GRID_TABLE_ID,
  DEFENSE_GRID_TABLE_NAME,
  IF_OF_TABLE_ID,
  IF_OF_TABLE_NAME,
  IF_OPINION_TABLE_ID,
  IF_OPINION_TABLE_NAME,
  OF_OPINION_TABLE_ID,
  OF_OPINION_TABLE_NAME,
} from './defenseGrids/constants';

const PlayerValuationSection = () => import('./playerValuation/PlayerValuationSection.vue');

tracing('DView');

Vue.use(HttpPlugin);
Vue.use(ResponsivePlugin);

window.CreateGVTicker = (player, placeholder) => {
  new Vue({
    el: placeholder,
    components: {
      'root-component': () => import('./GameViewTickerSection.vue'),
    },
    render: (h) =>
      h('root-component', {
        props: {
          player,
          bottomMargin: '0',
        },
      }),
  });
};

window.CreatePlayerOverviewSection = (playerID, placeholder) => {
  if (window.PlayerOverviewSectionVue) {
    let instance = window.PlayerOverviewSectionVue;
    instance.$destroy();
    instance.$el.parentNode.removeChild(instance.$el);
  }

  window.PlayerOverviewSectionVue = new Vue({
    el: placeholder,
    render: (h) =>
      h(PlayerOverviewSection, {
        props: {
          playerID: playerID,
        },
      }),
  });
};

window.CreateBatMetricsTable = function (playerID, placeholder, bats) {
  new Vue({
    el: placeholder,

    render: (h) =>
      h(BatMetricTableSection, {
        props: {
          playerID,
          isSwitchHitter: bats === 'S',
          defaultBatHandedId: bats === 'S' ? 0 : bats === 'L' ? 1 : 2,
        },
      }),
  });
};

window.CreateIFOFDefPerformanceTable = function (player, placeholder, mainContainerSelector) {
  addToQuickNav(mainContainerSelector, IF_OF_TABLE_ID, IF_OF_TABLE_NAME);
  new Vue({
    el: placeholder,
    name: 'IFOFPerformanceTable',
    render: (h) =>
      h(IFOFDefPerformanceTable, {
        props: {
          player,
          mainContainerSelector,
        },
      }),
  });
};

window.CreateCatcherProcessTable = function (player, placeholder, mainContainerSelector) {
  addToQuickNav(mainContainerSelector, CATCHER_PROCESS_TABLE_ID, CATCHER_PROCESS_TABLE_NAME);
  new Vue({
    el: placeholder,
    name: 'CatcherProcessTable',
    render: (h) =>
      h(CatcherProcessTable, {
        props: {
          player,
          mainContainerSelector,
        },
      }),
  });
};

window.CreateCatcherPerformanceTable = function (player, placeholder, mainContainerSelector) {
  addToQuickNav(mainContainerSelector, CATCHER_TABLE_ID, CATCHER_TABLE_NAME);
  new Vue({
    el: placeholder,
    name: 'CatcherPerformanceTable',
    render: (h) =>
      h(CatcherDefPerformanceTable, {
        props: {
          player,
          mainContainerSelector,
        },
      }),
  });
};

window.CreateIFDefOpinion = function (player, placeholder, mainContainerSelector) {
  addToQuickNav(mainContainerSelector, IF_OPINION_TABLE_ID, IF_OPINION_TABLE_NAME);
  new Vue({
    el: placeholder,
    name: 'IFOpinion',
    render: (h) =>
      h(IFOpinion, {
        props: {
          player,
          mainContainerSelector,
        },
      }),
  });
};

window.CreateOFDefOpinion = function (player, placeholder, mainContainerSelector) {
  addToQuickNav(mainContainerSelector, OF_OPINION_TABLE_ID, OF_OPINION_TABLE_NAME);
  new Vue({
    el: placeholder,
    name: 'OFOpinion',
    render: (h) =>
      h(OFOpinion, {
        props: {
          player,
          mainContainerSelector,
        },
      }),
  });
};

window.CreateDefenseGrid = function (player, placeholder, mainContainerSelector, showQuickNav = true) {
  if (showQuickNav) {
    addToQuickNav(mainContainerSelector, DEFENSE_GRID_TABLE_ID, DEFENSE_GRID_TABLE_NAME);
  }
  new Vue({
    el: placeholder,
    name: 'DefenseGrid',
    render: (h) =>
      h(DefenseGrid, {
        props: {
          player,
          mainContainerSelector,
          showQuickNav,
        },
      }),
  });
};

window.CreateInjuryForecastTable = function (playerID, placeholder) {
  if (appConstantData.Permissions.includes('DVCanSeefxwOBAfxFIP')) {
    if (window.InjuryForecastSectionVue) {
      let instance = window.InjuryForecastSectionVue;
      instance.$destroy();
      instance.$el.parentNode.removeChild(instance.$el);
    }
    window.InjuryForecastSectionVue = new Vue({
      el: placeholder,

      render: (h) =>
        h(InjuryForecast, {
          props: {
            playerID,
          },
        }),
    });
  }
};

window.CreateAmateurMedicalTable = function (playerID, placeholder, appConstantData) {
  if (window.AmateurMedicalSectionVue) {
    let instance = window.AmateurMedicalSectionVue;
    instance.$destroy();
    instance.$el.parentNode.removeChild(instance.$el);
  }
  window.AmateurMedicalSectionVue = new Vue({
    el: placeholder,
    render: (h) =>
      h(AmateurMedical, {
        props: {
          playerID: playerID,
          appConstantData,
        },
      }),
  });
};

window.BatFXSwingGrades = (playerID, id) => {
  window.BatFXSwingGradesVue = new Vue({
    el: `#${id}`,
    render: (h) =>
      h(FxSwingGrades, {
        props: {
          playerID,
        },
        class: 'tableContainer',
      }),
  });
};

window.CreatePlayerJournalEntryModalContent = function (
  placeholder,
  currentPlayerID,
  isNew,
  journalEntryObj,
  jeCatData,
  onSaveCallback,
  onCloseCallback,
) {
  if (window.PlayerJournalEntryModalContentVue) {
    let instance = window.PlayerJournalEntryModalContentVue;
    instance.$destroy();
    instance.$el.parentNode.removeChild(instance.$el);
  }
  window.PlayerJournalEntryModalContentVue = new Vue({
    render: (h) =>
      h(PlayerJournalEntryModalContent, {
        props: {
          playerID: currentPlayerID,
          isNewEntry: isNew,
          journalEntry: journalEntryObj,
          journalCategories: jeCatData.sort((a, b) => a.DisplayOrder - b.DisplayOrder),
        },
        on: {
          save: onSaveCallback,
          cancel: onCloseCallback,
        },
      }),
  }).$mount(placeholder);
};

window.CreatePlayerValuationSection = function (playerId, placeholder) {
  new Vue({
    el: placeholder,
    render: (h) =>
      h(PlayerValuationSection, {
        props: {
          playerId: playerId,
        },
      }),
  });
};
